module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/piggybank-6954ef92a345ceb0cf8d729f3e0be9ae.png";